(() => {
  const init = () => {
    const article = document.querySelector('.article-template');
    const panel = article?.querySelector('#halo-sidebar');
    const trigger = article?.querySelector('[data-sidebar]');
    if (!panel || !trigger) return;
    const mobile = matchMedia('(max-width: 1024px)');
    const inerted = new Set();
    let opened = false;
    const release = () => {
      inerted.forEach(element => { element.inert = false; });
      inerted.clear();
    };
    const focusables = () => [...panel.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')]
      .filter(element => !element.disabled && element.tabIndex >= 0 && !element.closest('[inert]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    const close = () => document.body.classList.remove('open-mobile-sidebar');
    const sync = () => {
      const open = mobile.matches && document.body.classList.contains('open-mobile-sidebar');
      trigger.setAttribute('aria-expanded', String(open));
      panel.inert = mobile.matches && !open;
      if (open === opened) return;
      opened = open;
      if (open) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('aria-label', trigger.getAttribute('aria-label'));
        let current = panel;
        while (current.parentElement) {
          for (const sibling of current.parentElement.children) {
            if (sibling !== current && !sibling.inert && !sibling.matches('script,style,link')) {
              sibling.inert = true;
              inerted.add(sibling);
            }
          }
          current = current.parentElement;
          if (current === document.body) break;
        }
        panel.querySelector('[data-close-sidebar]')?.focus({preventScroll: true});
      } else {
        release();
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        panel.removeAttribute('aria-label');
        if (mobile.matches) trigger.focus({preventScroll: true});
      }
    };
    document.addEventListener('keydown', event => {
      if (!opened) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        close();
        sync();
      } else if (event.key === 'Tab') {
        const items = focusables();
        const first = items[0], last = items[items.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
          event.preventDefault(); first.focus();
        }
      }
    }, true);
    mobile.addEventListener('change', () => { if (!mobile.matches) close(); sync(); });
    new MutationObserver(sync).observe(document.body, {attributes: true, attributeFilter: ['class']});
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
